import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved


function Official(data) {
    if (data) {
        _.extend(this, data);
    }
}

Official.prototype.getDisplayName = function (defaultName) {
    return format(this, ' ') || defaultName;
};

export default Official;
